import { useState, React, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import HeaderMobile from './components/Header';
import { addDays, format } from 'date-fns';
import { Button, FormControl, InputLabel, OutlinedInput } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import BidGroup from './components/BidGroup';
import { useAuth } from '../../contexts/AuthContext';
import { usePost } from '../../apis/ApiRequests';
import CustomOutlinedInput from '../../components/input/CustomOutlinedInput';
import CustomSelect from '../../components/select/CustomSelect';
import CustomSnackBar from '../../components/alert/CustomSnackBar';
import CustomConfirm from '../../components/confirm/CustomConfirm';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import BackspaceIcon from '@mui/icons-material/Backspace';
import SkipNextIcon from '@mui/icons-material/SkipNext';

const BidRegisterMobile = () => {

	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const { authInfo }   = useAuth();
    const facilityCode = authInfo.facilityCode;
    const facilityName = authInfo.facilityName;
    const userId       = authInfo.userId;
    const userName     = authInfo.userName;
    const authority    = authInfo.authority;
    const traderCode   = authInfo.traderCode;
    const trader       = authInfo.trader;
    
    const navigate = useNavigate();
    
    const search     = useLocation().search;
    const query      = new URLSearchParams(search);
    const bidGroupNo = query.get('bidGroupNo');
    const seq        = query.get('seq');
    const targetDate = query.get('targetDate');
    const today      = targetDate ? targetDate : format(addDays(new Date(), 0), 'yyyy-MM-dd');
    
	//-----------------------------------------------
	// initialize - useState
	//-----------------------------------------------
	const [ searchCount,     setSearchCount     ] = useState(0);
	const [ bidGroup,        setBidGroup        ] = useState([]);
    const [ bidList,         setBidList         ] = useState([]);
    const [ bidUnitList,     setBidUnitList     ] = useState([]);
    const [ commentList,     setCommentList     ] = useState([]);
    const [ requireMessage,  setRequireMessage  ] = useState('');
    const [ registerMessage, setRegisterMessage ] = useState('');
    const [ cancelMessage,   setCancelMessage   ] = useState('');
    const [ noBidMessage,    setNoBidMessage    ] = useState('')
	const [ dataGridHeight,  setDataGridHeight  ] = useState(window.innerHeight - 220);
    const [ maxPrice,        setMaxPrice        ] = useState('');
    
    // 登録データ
    const [ registerData, setRegisterData ] = useState({
        facilityCode  : facilityCode,
        userId        : userId,
        activeFlag    : 1,
        userId        : userId,
        bidGroupNo    : bidGroupNo,
        traderCode    : traderCode,
        trader        : trader,
        entryUserId   : userId,
        entryUser     : userName,
        seq           : seq,
        ip            : '',
        entrySuryo    : 0,
        entryUnit     : 1,
        tanka         : '',
        conditionCode : '',
        condition     : '',
        bidStatus     : 0,
        bidMode       : '',
    });
    // UI Message
    const [ messageState, setMessageState ] = useState({
        snackBarTrue         : false,
        snackBarFalse        : false,
        require              : false,
        confirm              : false,
        confirm_register     : false,
        confirm_price_before : false,
        confirm_price_after  : false,
        confirm_noBid        : false,
    });
    
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
    // API - getData / BidGroup
	//-----------------------------------------------
    const { response : getData_res, loading : getData_Loading, post:getData_post } = usePost();
    const getData = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidGroup',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'bidGroupNo'   : bidGroupNo
        }
        await getData_post(postData);
    };
	//-----------------------------------------------
    // API - getDataInGroup / BidList
	//-----------------------------------------------
    const { response : getDataInGroup_res, loading : getDataInGroup_Loading, post:getDataInGroup_post } = usePost();
    const getDataInGroup = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'getDataInGroup',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'bidGroupNo'   : bidGroupNo
        }
        await getDataInGroup_post(postData);
    };
	//-----------------------------------------------
    // API - getNextNo / BidList
	//-----------------------------------------------
    const { response : getData_history_res, post : getData_history_post } = usePost();
    const getData_history = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidHistory',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'bidGroupNo'   : bidGroupNo,
            'traderCode'   : traderCode,
            'seq'          : seq
        }
        await getData_history_post(postData);
    };
	//-----------------------------------------------
    // API - getNextNo / BidList
	//-----------------------------------------------
    const { response : getNextNo_res, post : getNextNo_post } = usePost();
    const getNextNo = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidHistory',
            'methodName'   : 'getNextNo',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'bidGroupNo'   : bidGroupNo,
            'traderCode'   : traderCode
        }
        await getNextNo_post(postData);
    };
	//-----------------------------------------------
    // API - setData / BidHistory
	//-----------------------------------------------
    const { response : setData_res, post:setData_post } = usePost();
    const setData = async (targetData) => {
        if (targetData.entryUnit == 2) {
            targetData.entrySuryo = Math.floor(targetData.entrySuryo);
        }
        const postData = {
            'className'     : 'mch.models.table.BidHistory',
            'methodName'    : 'setDataByTrader',
            'facilityCode'  : facilityCode,
            'userId'        : userId,
            'activeFlag'    : targetData.activeFlag,
            'userId'        : targetData.userId,
            'bidGroupNo'    : targetData.bidGroupNo,
            'seq'           : targetData.seq,
            'traderCode'    : targetData.traderCode,
            'trader'        : targetData.trader,
            'entryUserId'   : targetData.entryUserId,
            'entryUser'     : targetData.entryUser,
            'ip'            : targetData.ip,
            'entrySuryo'    : targetData.entryUnit == 1 ? 0 : targetData.entrySuryo,
            'entryUnit'     : (targetData.entrySuryo == 0 || targetData.entrySuryo == 0.0) ? 1 : targetData.entryUnit,
            'tanka'         : targetData.tanka,
            'conditionCode' : targetData.conditionCode,
            'condition'     : targetData.condition,
            'bidStatus'     : targetData.bidStatus, 
        }
        await setData_post(postData);
    };
	//-----------------------------------------------
    // API - searchData / masta.Comment
	//-----------------------------------------------
    const { response : getDataAll_comment_res, post : getDataAll_comment_post } = usePost();
    const getDataAll_comment = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Comment',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_comment_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.Comment
	//-----------------------------------------------
    const { response : getData_comment_res, post : getData_comment_post } = usePost();
    const getData_comment = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Comment',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_comment_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.FishSpec
	//-----------------------------------------------
    const { response : getData_fishSpec_res, post : getData_fishSpec_post } = usePost();
    const getData_fishSpec = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.OriginalFishSpec',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_fishSpec_post(postData);
    };
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {

        setSearchCount(searchCount+1);
        
        const handleResize = () => {
            setDataGridHeight(window.innerHeight - 220);
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    },[]);
	//-----------------------------------------------
    // useEffect - 検索処理
	//-----------------------------------------------
    useEffect(() => {
        setRegisterData(prevSearchData => ({
            ...prevSearchData,
            seq           : '',
            tanka         : '',
            entrySuryo    : 0,
            entryUnit     : 1,
            conditionCode :'',
        }));
        getData();
        getDataInGroup();
        getDataAll_comment();
        if (seq) getData_history();
    }, [searchCount]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / unloadList)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_res) {
            setBidGroup({ ...getData_res });
            /*
            if (getData_res.kgKubun == 1) {
                registerData.entryUnit = 2;
            } else {
                registerData.entryUnit = 4;
            }
            if (getData_res.bidMode == 1) {
                registerData.entryUnit = 5;
            }
            if (getData_res.bidMode == 2) {
                registerData.entryUnit = 4;
            }
                */
            getData_fishSpec(getData_res.gyoshuCode);
        }
    }, [getData_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / unloadList)
	//-----------------------------------------------
    useEffect(() => {
        setBidList([]);
        if (getDataInGroup_res) {
            setBidList(getDataInGroup_res.Data);
        }
    }, [getDataInGroup_res]);
    
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / unloadList)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_history_res) {
            setRegisterData({ ...getData_history_res });
        }
    }, [getData_history_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getNextId / bidList)
	//-----------------------------------------------
    useEffect(() => {
        if (getNextNo_res) {
            const targetData = { ...registerData, seq: getNextNo_res.seq };
            const requireStatus = checkedRequire(); // 必須項目をチェックする
            if (requireStatus) {
                setData(targetData);
                setMessageInfo('confirm_register', false);
                setMessageInfo('confirm_price_before', false);
                setMessageInfo('confirm_price_after', false);
                setMessageInfo('snackBarTrue', true);
                setSearchCount(searchCount+1);
            } else {
                setMessageInfo('confirm_register', false);
                setMessageInfo('require', true);
            }
        }
    }, [getNextNo_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(setData / bidList)
	//-----------------------------------------------
    useEffect(() => {
        if (setData_res) {
            if (setData_res.statusCode == 9) {
                setRequireMessage('落札済みのため入札できません');
                setMessageInfo('require', true);
            } else if (setData_res.statusCode == 8) {
                setRequireMessage('開票中のため入札できません');
                setMessageInfo('require', true);
            } else if (setData_res.statusCode == 0) {
                setRequireMessage('入札が解除されたため入札できません');
                setMessageInfo('require', true);
            } else {
                setSearchCount(searchCount+1);
    
                setMessageInfo('confirm', false);
                setMessageInfo('snackBarTrue', true);

                navigate(`/bidManagerMobile?targetDate=${today}&bidGroupNo=${ bidGroupNo }`);
            }
        }
    }, [setData_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getDataAll / masta_comment)
	//-----------------------------------------------
    useEffect(() => {
        setCommentList([]);
        if (getDataAll_comment_res) {
            getDataAll_comment_res.Data.unshift({id:'0',name:'未選択'});
            setCommentList(getDataAll_comment_res.Data);
        }
    }, [getDataAll_comment_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_comment)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_comment_res) {
            handleChange('conditionCode', getData_comment_res.code);
            handleChange('condition', getData_comment_res.displayName);
        }
    }, [getData_comment_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_fishSpec)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_fishSpec_res && bidGroup) {
            
            const array = [{ id: '1', name: '全量' }];
            if (bidGroup.kgKubun == 1) {
                array.push({ id: '2', name: 'Kg' });
                array.push({ id: '3', name: 'D' });
            } else {
                array.push({ id: '4', name: '箱' });
            }
            setBidUnitList(array);
            
            if (getData_fishSpec_res.maxPrice) setMaxPrice(getData_fishSpec_res.maxPrice);
        }
    }, [getData_fishSpec_res, bidGroup]);
    
	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - データの設定
	//-----------------------------------------------
    const handleChange = (name, value) => {
        //if (name == 'entrySuryo') value = Math.floor(value)
        setRegisterData(prevSearchData => ({
            ...prevSearchData,
            [name]: value,
        }));
        if (name == 'entryUnit' && value == 1) {
            registerData.entrySuryo = 0;
            setRegisterData(prevSearchData => ({
                ...prevSearchData,
                entrySuryo: '0',
            }));
        }
    };
	//-----------------------------------------------
    // eventHandler - コメントの変更
	//-----------------------------------------------
    const handleChange_comment = (value) => {
        getData_comment(value);
    };
	//-----------------------------------------------
    // eventHandler - 登録ボタン
	//-----------------------------------------------
    const handleClick_Register = async (activeFlag) => {
        const targetData = { ...registerData, activeFlag };
        // 新規の場合はuniqueIdを発行して登録処理を実行
        if (!targetData.seq) {
            await getNextNo();
        
        // 更新の場合は既存のuniqueIdに対して登録処理を実行
        } else {
            const requireStatus = checkedRequire(); // 必須項目をチェックする
            if (requireStatus) {
                await setData(targetData);
                setSearchCount(searchCount+1);
                setMessageInfo('confirm', false);
                setMessageInfo('confirm_register', false);
                setMessageInfo('confirm_price_before', false);
                setMessageInfo('confirm_price_after', false);
                setMessageInfo('confirm_noBid', false)
                setMessageInfo('snackBarTrue', true);
            } else {
                setMessageInfo('confirm_register', false);
                setMessageInfo('require', true);
            }
        }
        return false;
    };
	//-----------------------------------------------
    // eventHandler - 札入なしボタンのクリック
	//-----------------------------------------------
    const handleClick_noBid_before = async () => {
        setNoBidMessage('')
        if(getData_history_res){
            setRequireMessage('すでに入札済みか、札入なしの状態です')
            setMessageInfo('require', true)
        } else {
            setNoBidMessage(
                <>
                    「札入なし」にします。<br />
                    よろしいですか？
                </>
            )
            setMessageInfo('confirm_noBid', true)
        }
    }
	//-----------------------------------------------
    // eventHandler - 札入なしの処理
	//-----------------------------------------------
    const handleClick_noBid = async () => {

        setRegisterData(prevSearchData => ({
            ...prevSearchData,
            activeFlag    : 1,
            tanka         : -1,
            entrySuryo    : -1,
            entryUnit     : -1,
            bidStatus     : 9,
            conditionCode : '',
        }))
        
        await getNextNo()
        await setData(registerData)
        setMessageInfo('confirm_noBid', false)
        setMessageInfo('snackBarTrue', true)
        setRegisterData(prevSearchData => ({
            ...prevSearchData,
            tanka         : "",
            bidStatus     : 0,
        }))
    } 
	//===============================================
	// Function
	//===============================================
	//-----------------------------------------------
	// Function - 概算の金額を算出する
	//-----------------------------------------------
    const handleClick_Register_before = () => {

        const requireStatus = checkedRequire(); // 必須項目をチェックする
        if (requireStatus) {
            if (getData_history_res?.bidStatus === 9) { //札入れなしの場合
               setRequireMessage('すでに「札入なし」の状態です');
                setMessageInfo('require', true)
                return;
            }
            setRegisterMessage('');
            const entrySuryo   = Number(registerData.entrySuryo);
            const tanka        = Number(registerData.tanka);

            const kgDivision = bidGroup.kgKubun == 1 ? 'Kg代' : '箱代';
            let suryo = '';
            if (registerData.entryUnit == '1') {
                suryo = '全量';
            } else if (registerData.entryUnit == '2') {
                suryo = `${entrySuryo}Kg`;
            } else if (registerData.entryUnit == '3') {
                suryo = `${entrySuryo}Ⅾ`;
            } else if (registerData.entryUnit == '4') {
                suryo = `${entrySuryo}箱`;
            } else if (registerData.entryUnit == '5') {
                suryo = `${entrySuryo}匹`;
            }
            setRegisterMessage(
                <>
                <div style={{textAlign:'center'}}>
                    以下の内容で入札登録を行います。<br />
                    {kgDivision}<br />
                    単価：{tanka}円<br />
                    数量：{suryo}<br />
                    よろしいですか？
                </div>
                </>
            );
            // 単価が上限を超えていれば続けてコンファームを表示
            if (maxPrice && tanka >= maxPrice) {
                setMessageInfo('confirm_price_before', true);
            } else {
                setMessageInfo('confirm_register', true);
            }
        } else {
            setMessageInfo('require', true);
        }
    };
	//-----------------------------------------------
	// Function - 入札単価が上限を超えた場合のコンファーム表示
	//-----------------------------------------------
    const handleClick_Register_after = () => {
        setMessageInfo('confirm_price_before', false);
        setRegisterMessage('');
        const tanka = Number(registerData.tanka);
        setRegisterMessage(
            <>
            <div style={{fontWeight:'bold', textAlign:'center'}}>
                単価の入力に間違いないかご確認ください。<br />
                <span style={{color:'red', textDecoration:'underLine'}}>単価：{tanka}円</span><br />
                よろしいですか？
            </div>
            </>
        );
        setMessageInfo('confirm_price_after', true);
    };
	//-----------------------------------------------
	// Function - 必須項目をチェックする
	//-----------------------------------------------
    const checkedRequire = () => {
        const errorFields = [];
        if (!registerData.tanka) errorFields.push('「単価」');
        if (registerData.entrySuryo === '') {
            errorFields.push('「入札数量」');
        }
        if (!registerData.entryUnit) errorFields.push('「入札単位」');
        if (registerData.entryUnit == '0') errorFields.push('「入札単位」');
    
        if (errorFields.length) {
            const text = errorFields.join('、') + 'が入力されていません';
            setRequireMessage(text);
            return false;  // エラーがある場合は false を返します
        }
        let tankaText = registerData.tanka;
        if (typeof tankaText !== 'string') {
            tankaText = String(tankaText);
        }
        if (tankaText.includes('.')) {
            setRequireMessage('単価に小数点が含まれています');
            return false;
        }
        let entrySuryoText = registerData.entrySuryo;
        if (typeof entrySuryoText !== 'string') {
            entrySuryoText = String(entrySuryoText);
        }
        if (entrySuryoText.includes('.')) {
            setRequireMessage('数量に小数点が含まれています');
            return false;
        }
        // 入札数量のチェック
        if (registerData.entryUnit != '1' && registerData.entrySuryo == 0) {
            setRequireMessage('入札数量が0になっています');
            return false;  // エラーがある場合は false を返します
        }
        //const num = parseInt(registerData.tanka, 10);
        //if (!isNaN(num) && num > 999999) {
        //    setRequireMessage('単価に999,999円以上は指定できません')
        //    return false;  // エラーがある場合は false を返します
        //}

        // 入札数量のチェック
        const entrySuryo = parseFloat(registerData.entrySuryo); // 数値として取得
        if (registerData.entryUnit == 2) {
            if ((entrySuryo != 0 || entrySuryo != 0.0) && entrySuryo < 10) {
                setRequireMessage('Kg指定時は「入札数量」を10Kg以上で入札してください');
                return false;
            }
            if (entrySuryo % 5 !== 0) {
                setRequireMessage('Kg指定時は「入札数量」を5Kg単位で入札してください');
                return false;
            }
            if (bidGroup.kgSuryo < entrySuryo) {
                setRequireMessage('「入札数量」が規定のKg数量を超過しています');
                return false;
            }
        }
        if (registerData.entryUnit == 3 || registerData.entryUnit == 4) {
            if (bidGroup.suryo < entrySuryo) {
                setRequireMessage('「入札数量」が規定の数量を超過しています');
                return false;
            } 
        }
        if (bidGroup.bidMode == 1 || bidGroup.bidMode == 2) {
            if (bidGroup.suryo < entrySuryo) {
                setRequireMessage('「入札数量」が規定の数量を超過しています');
                return false;
            }
        }
        return true;  // エラーがない場合は true を返します
    }
	//-----------------------------------------------
	// Function - 入札の取り消しを行う
	//-----------------------------------------------
    const handleClick_Cancel_before = () => {

        setCancelMessage('');

        const tanka = Number(registerData.tanka);
        if (tanka) {
            setCancelMessage(
                <>
                  単価{tanka}円の入札を取り消します。<br />
                  よろしいですか？
                </>
            );
            setMessageInfo('confirm', true);
        } else {
            setRequireMessage('取り消しを行う入札情報を選択してください');
            setMessageInfo('require', true);
        }
    };
	//===============================================
	// UI Message
	//===============================================
    const setMessageInfo = (target, state) => {
        setMessageState(prevSearchData => ({
            ...prevSearchData,
            [target]: state,
        }));
    };
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <HeaderMobile />
            <div className='bidRegisterMobile bodyContens' style={{marginTop:'70px'}}>
                <div style={{marginTop:'0em', width: '100%', height: dataGridHeight, marginBottom: '10px', overflowY:'auto', overflowX:'hidden'}}>
                <BidGroup bidGroup={ bidGroup }/>
                    <div style={{display:'flex', marginTop:'10px', width:'100%'}}>
                        <div style={{width:'100%'}}>
                            {registerData.bidStatus === 9 ? ( // 札入なしの場合
                            <FormControl className="formcontrol" variant="outlined" size="small" sx={{ width: "100%"}} >
                              <InputLabel htmlFor="bidRegisterMobile_tanka"></InputLabel>
                              <OutlinedInput 
                              type      = "string"
                              id        = "bidRegisterMobile_tanka"
                              size      = "small"
                              value     = "札入なし"
                              readOnly
                              style     = {{backgroundColor:'#fff'}} />
                            </FormControl>
                            ) : (
                            <CustomOutlinedInput
                                type  = "number"
                                id    = "bidRegisterMobile_tanka"
                                label = "単価"
                                width = "100%"
                                value    = {registerData.tanka} 
                                onChange   = {(e) => handleChange('tanka', e.target.value)}
                            />
                            )}
                        </div>
                        <div style={{fontWeight:'bold', fontSize:'18px', padding:'5px',}}>円</div>
                    </div>
                    <div style={{marginLeft:'0px', display:'flex', marginTop:'10px', width:'100%', marginRight:'1em'}}>
                        <div style={{width:'100%'}}>
                            <CustomOutlinedInput
                                type  = "number"
                                id    = "bidRegisterMobile_entrySuryo"
                                label = "入札数量"
                                width = "100%"
                                value    = {registerData.bidStatus === 9 ? "" : registerData.entrySuryo} 
                                onChange   = {(e) => {
                                    if (registerData.bidStatus === 9) return;
                                    handleChange('entrySuryo', e.target.value)}}
                            />
                        </div>
                        <div style={{marginLeft:'10px',}}>
                            <CustomSelect
                                id         = "bidRegisterMobile_entryUni"
                                label      = "単位"
                                width      = "100px"
                                dataList   = {registerData.bidStatus === 9 ? [] : bidUnitList} 
                                selectedId = {registerData.entryUnit} 
                                onChange   = {(e) => {
                                    if (registerData.bidStatus === 9) return;
                                    handleChange('entryUnit', e.target.value)}}
                            />
                        </div>
                    </div>
                    <div style={{marginTop:'10px', width:'100%'}}>
                        <CustomSelect
                            id         = "bidRegisterMobile_condition"
                            label      = "入札条件"
                            width      = "100%"
                            dataList   = {registerData.bidStatus === 9 ? [] : commentList} 
                            selectedId = {registerData.conditionCode}
                            onChange   = {(e) => {
                                    if (registerData.bidStatus === 9) return;
                                    handleChange_comment(e.target.value)}}
                        />
                    </div>
                    <div style={{ position: 'fixed', left: 0, bottom: 0, width: '100%', color: 'white', textAlign: 'center' }}>
                        <Button
                            color     = "primary"
                            size      = "large"
                            style     = {{ fontSize: '20px', width: '90%', marginTop: '1rem', marginBottom: '1rem', color:'#fff'}}
                            variant   = "contained"
                            startIcon = {<AddCircleIcon />}
                            onClick   = {() => handleClick_Register_before()}
                        >登録
                        </Button>
                        <Button
                            color     = "primary"
                            size      = "large"
                            style     = {{ fontSize: '20px', width: '45%', marginTop:'0', color:'#fff', backgroundColor:'red' }}
                            variant   = "contained"
                            startIcon = {<BackspaceIcon />}
                            onClick   = {() => handleClick_Cancel_before()}
                        >取消
                        </Button>
                        <Button
                            color     = "secondary"
                            size      = "large"
                            style     = {{ fontSize: '20px', width: '45%',marginLeft: '0.2rem', color:'#fff' }}
                            variant   = "contained"
                            startIcon = {<SkipNextIcon />}
                            onClick   = {() => handleClick_noBid_before()}
                        >札入なし
                        </Button>
                        <Button
                            color     = "secondary"
                            size      = "large"
                            style     = {{ fontSize: '20px', width: '90%', marginTop: '1rem', marginBottom: '1rem', color:'#fff', backgroundColor:'grey' }}
                            variant   = "contained"
                            startIcon = {<InfoIcon />}
                            onClick   = {() => { navigate(`/bidManagerMobile?targetDate=${today}&bidGroupNo=${ bidGroupNo }`) }}
                        >入札情報へ戻る
                        </Button>
                    </div>

                </div>
                <CustomSnackBar
                    open            = {messageState.snackBarTrue}
                    onClose         = {() => setMessageInfo('snackBarTrue', false)}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "登録しました"
                />
                <CustomSnackBar
                    open            = {messageState.snackBarFalse}
                    onClose         = {() => setMessageInfo('snackBarFalse', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = "登録に失敗しました"
                />
                <CustomSnackBar
                    open            = {messageState.require}
                    onClose         = {() => setMessageInfo('require', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = {requireMessage}
                />
                <CustomConfirm
                    open      = {messageState.confirm}
                    onClose   = {() => setMessageInfo('confirm', false)}
                    onClickNG = {() => setMessageInfo('confirm', false)}
                    onClickOK = {() => handleClick_Register(0)}
                    message   = {cancelMessage}
                />
                <CustomConfirm
                    open      = {messageState.confirm_register}
                    onClose   = {() => setMessageInfo('confirm_register', false)}
                    onClickNG = {() => setMessageInfo('confirm_register', false)}
                    onClickOK = {() => handleClick_Register('1')}
                    message   = {registerMessage}
                />
                <CustomConfirm
                    open      = {messageState.confirm_price_before}
                    onClose   = {() => setMessageInfo('confirm_price_before', false)}
                    onClickNG = {() => setMessageInfo('confirm_price_before', false)}
                    onClickOK = {() => handleClick_Register_after()}
                    message   = {registerMessage}
                />
                <CustomConfirm
                    open      = {messageState.confirm_price_after}
                    onClose   = {() => setMessageInfo('confirm_price_after', false)}
                    onClickNG = {() => setMessageInfo('confirm_price_after', false)}
                    onClickOK = {() => handleClick_Register('1')}
                    message   = {registerMessage}
                />
                <CustomConfirm
                    open      = {messageState.confirm_noBid}
                    onClose   = {() => setMessageInfo('confirm_noBid', false)}
                    onClickNG = {() => setMessageInfo('confirm_noBid', false)}
                    onClickOK = {() => handleClick_noBid()}
                    message   = {noBidMessage}
                />
            </div>
        </>
    )
}

export default BidRegisterMobile;